import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App.js";
import './index.css'
import {
  ConvexReactClient
} from "convex/react";
import { ConvexProviderWithClerk } from "convex/react-clerk";
import { ClerkProvider, useAuth } from "@clerk/clerk-react";

const convex = new ConvexReactClient(process.env.REACT_APP_CONVEX_URL);

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <ClerkProvider
      // Replace this with your Clerk Publishable Key
      // or with `{import.meta.env.VITE_CLERK_PUBLISHABLE_KEY}`
      // and configure VITE_CLERK_PUBLISHABLE_KEY in your .env.local
      publishableKey="pk_test_Y2hhcm1lZC1tYWdwaWUtNjYuY2xlcmsuYWNjb3VudHMuZGV2JA"
    >
      <ConvexProviderWithClerk client={convex} useAuth={useAuth}>
          <Router>
            <App />
          </Router>
      </ConvexProviderWithClerk>
    </ClerkProvider>
  </React.StrictMode>
);
